import React, { Fragment } from 'react';

import PagesLoginContent from '../../Components/PagesLogin/PagesLoginContent';
export default function PagesLogin() {
  return (
    <Fragment>
      <PagesLoginContent />
    </Fragment>
  );
}
